import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export type TrackingDetailData = {
    접수idx: string;
    운송장번호: string;
    운송장출력번호: string[];
    진행시간: string;
    접수일자: string;
    진행코드: [string, string];
    배송상세: {
        진행코드명: string;
        진행담당자및주소: string;
        담당자: string;
        진행시간: string;
    }[];
    버튼노출: string;
    발송구분: string;
    지불방법: string;
    요금처: string;
    담당자: string;
    수량: string;
    메모: string;
    출발지상호: string;
    출발지신용정보: string;
    출발지연락처: string;
    출발지담당자: string;
    출발지주소: string;
    출발지우편번호: string;
    도착지상호: string;
    도착지신용정보: string;
    도착지연락처: string;
    도착지담당자: string;
    도착지주소: string;
    롤: number;
    박스: number;
    샘플: number;
    배송완료사진: string | null;
};

type GetTrackingDetailResponse = {
    statusCode: number;
    message: string;
    data: TrackingDetailData;
};

export const useGetTrackingDetail = (bl_no: string): UseQueryResult<TrackingDetailData, Error> => {
    return useQuery<TrackingDetailData, Error>({
        queryKey: ["useGetTrackingDetail", bl_no],
        queryFn: async () => {
            const isTypeA = bl_no.startsWith("1");
            const endpoint = isTypeA ? enum_api_uri.tracking_detailA : enum_api_uri.tracking_detail;

            const { data } = await axiosInstance.get<GetTrackingDetailResponse>(`${endpoint}?bl_no=${bl_no}`);

            if (data.statusCode !== 200) {
                throw new Error(data.message || "조회 실패");
            }

            return data.data;
        },
        enabled: !!bl_no,
    });
};
